var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { matchPath } from 'react-router-dom';
import { ApplicationSectionStatus } from '../../../../shared/types/enums';
import { services, formTypeName } from '../../../../shared';
import { APPLICATION, FEES, CASEDOCUMENTS, CASEDECLARATIONS, ILLUSTRATION, } from '../../../../config/routes';
var matchAnyPage = function (routes) {
    return (routes === null || routes === void 0 ? void 0 : routes.find(function (route) { return matchPagePath(route.path); })) != null;
};
var matchPagePath = function (path) {
    return matchPath(window.location.pathname, {
        path: path,
        exact: true,
    });
};
export var manageCaseRouteNavigation = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var pageWithStatus, defaultResult, path, page;
    var _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return __generator(this, function (_t) {
        switch (_t.label) {
            case 0: return [4 /*yield*/, fetchPageWithStatus(options.params.caseId, options.step, options.params.sectionId, options.setPages)];
            case 1:
                pageWithStatus = _t.sent();
                _a = {
                    requiresRedirect: false,
                    url: window.location.pathname,
                    pageWithStatus: pageWithStatus
                };
                return [4 /*yield*/, reloadCaseLocation(options.location, options.params)];
            case 2:
                defaultResult = (_a.newLocation = _t.sent(),
                    _a);
                if (matchAnyPage([FEES, CASEDOCUMENTS, CASEDECLARATIONS, ILLUSTRATION]) ||
                    matchPagePath(APPLICATION.paths[APPLICATION.paths.length - 1])) {
                    return [2 /*return*/, defaultResult];
                }
                else if (matchPagePath(APPLICATION.paths[0]) || matchPagePath(APPLICATION.paths[1])) {
                    path = "".concat(APPLICATION.paths[0], "/").concat((_b = options.params.caseId) !== null && _b !== void 0 ? _b : 0, "/").concat((_f = (_c = options.params.loanPurposeId) !== null && _c !== void 0 ? _c : (_e = (_d = defaultResult.newLocation) === null || _d === void 0 ? void 0 : _d.state) === null || _e === void 0 ? void 0 : _e.loanPurposeId) !== null && _f !== void 0 ? _f : 0, "/").concat((_j = (_h = (_g = options.step) === null || _g === void 0 ? void 0 : _g.formId) !== null && _h !== void 0 ? _h : options.params.formId) !== null && _j !== void 0 ? _j : 0);
                    if (((_k = options.step) === null || _k === void 0 ? void 0 : _k.formType) == formTypeName.illustration) {
                        path = "".concat(path, "/").concat(pageWithStatus.name);
                    }
                    else if (pageWithStatus.pages.filter(function (page) { return page.isComplete || page.name.toLowerCase() == 'submit'; }).length ==
                        pageWithStatus.pages.length) {
                        path = "".concat(path, "/Submit");
                    }
                    else {
                        if (((_l = pageWithStatus.pages) === null || _l === void 0 ? void 0 : _l.length) > 0) {
                            page = (_m = pageWithStatus.pages.find(function (page) {
                                return (page.applicationSectionStatus != ApplicationSectionStatus.Complete &&
                                    page.applicationSectionStatus != ApplicationSectionStatus.Partial) ||
                                    !page.isComplete;
                            })) !== null && _m !== void 0 ? _m : pageWithStatus.pages[0];
                            path =
                                ((_o = page.sections) === null || _o === void 0 ? void 0 : _o.length) > 0
                                    ? "".concat(path, "/").concat(page.id, "/").concat((_s = (_q = (_p = page.sections.find(function (section) {
                                        return section.applicationSectionStatus != ApplicationSectionStatus.Complete &&
                                            section.applicationSectionStatus != ApplicationSectionStatus.Partial;
                                    })) === null || _p === void 0 ? void 0 : _p.id) !== null && _q !== void 0 ? _q : (_r = page.sections[page.sections.length - 1]) === null || _r === void 0 ? void 0 : _r.id) !== null && _s !== void 0 ? _s : 0)
                                    : "".concat(path, "/").concat(page.name);
                        }
                    }
                    return [2 /*return*/, __assign(__assign({}, defaultResult), { requiresRedirect: true, url: path })];
                }
                return [2 /*return*/, defaultResult];
        }
    });
}); };
var fetchPageWithStatus = function (caseId, step, sectionId, setPages) { return __awaiter(void 0, void 0, void 0, function () {
    var sections, pageWithStatus, lastCompleted, pageWithSections, target;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                if (!step)
                    return [2 /*return*/, { id: 0, name: '', pages: [] }];
                sections = [];
                return [4 /*yield*/, services.getPagesWithStatus(caseId, step.formId)];
            case 1:
                pageWithStatus = (_h.sent()).data;
                if (setPages)
                    setPages(pageWithStatus);
                if (pageWithStatus) {
                    lastCompleted = pageWithStatus.findIndex(function (page) { return page.isComplete; });
                    pageWithSections = lastCompleted >= 0 ? (_a = pageWithStatus[lastCompleted + 1]) === null || _a === void 0 ? void 0 : _a.sections : null;
                    sections = (_c = pageWithSections !== null && pageWithSections !== void 0 ? pageWithSections : (_b = pageWithStatus[0]) === null || _b === void 0 ? void 0 : _b.sections) !== null && _c !== void 0 ? _c : [];
                }
                target = sectionId
                    ? Number(sectionId)
                    : (sections === null || sections === void 0 ? void 0 : sections.length) > 1
                        ? (_d = sections === null || sections === void 0 ? void 0 : sections.find(function (section) {
                            return section.applicationSectionStatus !== ApplicationSectionStatus.Complete &&
                                section.applicationSectionStatus !== ApplicationSectionStatus.Partial;
                        })) === null || _d === void 0 ? void 0 : _d.id
                        : (_f = (_e = sections[0]) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : 0;
                return [2 /*return*/, { id: target, name: (_g = pageWithStatus[0]) === null || _g === void 0 ? void 0 : _g.name, pages: pageWithStatus }];
        }
    });
}); };
export var reloadCaseLocation = function (location, params) { return __awaiter(void 0, void 0, void 0, function () {
    var loadedCase, _a, newLocation;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                if (!!((_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case)) return [3 /*break*/, 2];
                return [4 /*yield*/, services.getCase(params.caseId)];
            case 1:
                _a = (_k.sent()).data;
                return [3 /*break*/, 3];
            case 2:
                _a = null;
                _k.label = 3;
            case 3:
                loadedCase = _a;
                newLocation = !((_c = location === null || location === void 0 ? void 0 : location.state) === null || _c === void 0 ? void 0 : _c.case)
                    ? {
                        state: {
                            loanPurposeId: (_f = (_e = (_d = location === null || location === void 0 ? void 0 : location.state) === null || _d === void 0 ? void 0 : _d.loanPurposeId) !== null && _e !== void 0 ? _e : loadedCase === null || loadedCase === void 0 ? void 0 : loadedCase.loanPurposeId) !== null && _f !== void 0 ? _f : params.loanPurposeId,
                            case: loadedCase,
                            applicants: (_j = (_g = loadedCase === null || loadedCase === void 0 ? void 0 : loadedCase.applicants) !== null && _g !== void 0 ? _g : (_h = location === null || location === void 0 ? void 0 : location.state) === null || _h === void 0 ? void 0 : _h.applicants) !== null && _j !== void 0 ? _j : [],
                        },
                    }
                    : location;
                return [2 /*return*/, newLocation];
        }
    });
}); };
